import { render, staticRenderFns } from "./Updateprofile.vue?vue&type=template&id=601b14eb&scoped=true"
import script from "./Updateprofile.vue?vue&type=script&lang=js"
export * from "./Updateprofile.vue?vue&type=script&lang=js"
import style0 from "./Updateprofile.vue?vue&type=style&index=0&id=601b14eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601b14eb",
  null
  
)

export default component.exports